import React, { FC, ChangeEvent, useState, useEffect, useRef } from "react";
import {
  AppBar,
  Container,
  MenuItem,
  Toolbar,
  Typography,
  Box,
  FormControl,
  Input,
  InputAdornment,
  useTheme,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import SearchResultsContainer from "../SearchResultsContainer/SearchResultsContainer";
import { getStagesByName } from "../../Services/api";
import "./HeaderComponent.css";
import { useLocation } from "react-router-dom";
// import useFocusOnRouteChange from "../../Hooks/useFocusOnRouteChange";

const HeaderComponent: FC = () => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [results, setResults] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const searchRef = useRef<HTMLInputElement>(null);
  // const focusRef = useFocusOnRouteChange();

  useEffect(() => {
    setSearchTerm("");
    setIsOpen(false);
    setResults([]);
  }, [location]);

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      // If popup is not open, open it; otherwise just search
      if (!isOpen) setIsOpen(true);
      handleSearch();
    }
  };
  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchTerm.length >= 3) {
        setIsOpen(true);
        setIsLoading(true);
        getStagesByName(searchTerm)
          .then(setResults)
          .catch(() => setResults([]))
          .finally(() => setIsLoading(false));
      } else {
        setIsOpen(false);
        setResults([]);
      }
    }, 400);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;
    setIsLoading(true);
    setIsOpen(true);
    try {
      const data = await getStagesByName(searchTerm);
      setResults(data);
    } catch (err) {
      console.error(err);
      setResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (searchRef.current) searchRef.current.focus();
    setIsOpen(false);
  };

  return (
    <>
      <AppBar className="AppBar" position="static">
        <Container maxWidth={false}>
          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
            {isMobile && false && (
              <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
                <MenuIcon fontSize={"large"} />
              </IconButton>
            )}

            <Link
              tabIndex={0}
              // ref={focusRef}
              to="/"
              style={{
                textDecoration: "none",
                color: "inherit",
                cursor: "pointer",
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
              }}
            >
              {!isMobile && <img src="/images/logo.png" className="header-logo" alt="לוגו משרד ראש הממשלה" />}
              <Typography className="header-title">תשתיות לישראל</Typography>
            </Link>

            {!isMobile && (
              <Box className="header-search-container">
                <MenuItem>
                  <FormControl role={"search"} fullWidth sx={{ m: 1 }} variant="standard">
                    <Input
                      inputRef={searchRef}
                      id="search"
                      placeholder="חיפוש..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      onKeyPress={handleKeyPress}
                      sx={{
                        color: "#FFFFFF",
                        backgroundColor: "transparent",
                        "& .MuiInputBase-input": {
                          backgroundColor: "transparent !important",
                          "::placeholder": {
                            color: "#ffffff",
                            opacity: 1,
                          },
                        },
                        "&:before": {
                          borderBottom: "1px solid #fff",
                        },
                        "&:after": {
                          borderBottom: "2px solid #fff",
                        },
                        "&:hover:not(.Mui-disabled):before": {
                          borderBottom: "2px solid #fff",
                        },
                      }}
                      endAdornment={
                        <InputAdornment position="start">
                          <IconButton onClick={handleSearch} aria-label="חפש" aria-haspopup="dialog" size="small" sx={{ color: "#fff" }}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </MenuItem>
              </Box>
            )}

            {isMobile && (
              <IconButton edge="end" color="inherit" aria-label="search" onClick={() => setIsOpen(!isOpen)}>
                <SearchIcon fontSize={"large"} />
              </IconButton>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <SearchResultsContainer searchTerm={searchTerm} results={results} isLoading={isLoading} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};

export default HeaderComponent;
